/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_VOUCHER_LIST = '[Account] Update User Profile',
  GET_VOUCHER_LIST_SUCCESS = '[Account] User Profile Success',
  GET_VOUCHER_LIST_FAILED = '[Account] User Profile Failed',
}

export const getVoucherList = createAction(
  ActionTypes.GET_VOUCHER_LIST
);

export const getVoucherListSuccess = createAction(
  ActionTypes.GET_VOUCHER_LIST_SUCCESS,
  props<{ data: any }>()
);

export const getVoucherListFailed = createAction(
  ActionTypes.GET_VOUCHER_LIST_FAILED,
  props<{ data: any }>()
);